<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    collapsed?: boolean
    label?: string
    block?: boolean
  }>(),
  {
    collapsed: false,
    label: 'Suchen…',
    block: true,
  },
)

const { openCommandPalette } = useCommandPalette()
</script>

<template>
  <UButton
    :aria-label="props.collapsed ? props.label : undefined"
    :block="props.block"
    :label="props.collapsed ? undefined : props.label"
    :square="props.collapsed"
    color="neutral"
    icon="i-lucide-search"
    variant="outline"
    @click="openCommandPalette"
  >
    <template v-if="!props.collapsed" #trailing>
      <span class="ms-auto flex items-center gap-0.5">
        <UKbd value="meta" variant="subtle" />
        <UKbd value="K" variant="subtle" />
      </span>
    </template>
  </UButton>
</template>
